/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_State_AcceptedInputs */

const en_invite_state_accepted = /** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite was already accepted. Sign in to open the workspace.`)
};

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const ar_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const he_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const ur_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const es_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const fr_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const de_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const pt_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const hi_invite_state_accepted = en_invite_state_accepted;

/** @type {(inputs: Invite_State_AcceptedInputs) => LocalizedString} */
const bn_invite_state_accepted = en_invite_state_accepted;

/**
* | output |
* | --- |
* | "This invite was already accepted. Sign in to open the workspace." |
*
* @param {Invite_State_AcceptedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_state_accepted = /** @type {((inputs?: Invite_State_AcceptedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_State_AcceptedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_state_accepted(inputs)
	if (locale === "he") return he_invite_state_accepted(inputs)
	if (locale === "ur") return ur_invite_state_accepted(inputs)
	if (locale === "es") return es_invite_state_accepted(inputs)
	if (locale === "fr") return fr_invite_state_accepted(inputs)
	if (locale === "de") return de_invite_state_accepted(inputs)
	if (locale === "pt") return pt_invite_state_accepted(inputs)
	if (locale === "hi") return hi_invite_state_accepted(inputs)
	if (locale === "bn") return bn_invite_state_accepted(inputs)
	return /** @type {LocalizedString} */ ("This invite was already accepted. Sign in to open the workspace.")
});